import { Skeleton, Stack, StackProps } from '@mui/material';

import styles from './SearchResultShimmer.module.scss';

const SearchResultItemShimmer = () => (
  <Stack direction="row" className={styles.SearchResultShimmer}>
    <Skeleton variant="rounded" width={'100%'} height={22} />
  </Stack>
);

export const SearchResultShimmer = ({ ...props }: StackProps) => {
  return (
    <Stack gap={0.5} {...props}>
      {Array.from({ length: 8 }).map((_, index) => (
        <SearchResultItemShimmer key={index} />
      ))}
    </Stack>
  );
};
